import React from 'react';
import InputValidator from '../common/InputValidator.jsx';
import ValidatedComponent from '../common/ValidatedComponent.jsx';
import ChangeEmail from './ChangeEmail.jsx';
import Loading from '../common/Loading.jsx';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as ChangeEmailActions from './redux/actions.changeEmail';
import * as ProfileActions from './redux/actions';

class ProfileSecurity extends React.Component {
  render() {
    const {currentPassword, newPassword, confirmNewPassword} = this.props.passwordEdit;
    const {
      profile, isSaving, passwordEditErrors, errors,
      updateChangePassword, changeEmail, cancelChangeEmail, resendConfirmEmail, resendVerifyEmail
    } = this.props;

    return (
      <div className="ba-profile-security">
        <div className="row">
          <div className="small-12 columns">
            <h2 className="ba-page-header">Sign-in & security</h2>
            {
              isSaving && <Loading />
            }
          </div>
        </div>
        <div className="row ba-profile-panel">
          <div className="small-12 columns">
            <h2>Change Password</h2>
          </div>
          <div className="small-12 columns">
            <InputValidator fieldName="Current password"
                            errors={passwordEditErrors.currentPassword}>
              <input type="password"
                     value={currentPassword}
                     required
                     placeholder="Current password"
                     onChange={e => updateChangePassword({currentPassword: e.target.value})}/>
            </InputValidator>
          </div>
          <div className="small-12 columns">
            <InputValidator fieldName="New password"
                            errors={passwordEditErrors.newPassword}
                            customValidation={() => {
                              return this.validatePasswords();
                            }}>
              <input type="password"
                     value={newPassword}
                     required
                     placeholder="New password"
                     onChange={e => updateChangePassword({newPassword: e.target.value})}/>
            </InputValidator>
          </div>
          <div className="small-12 columns">
            <InputValidator fieldName="Confirm new password"
                            customValidation={() => {
                              return this.validatePasswords();
                            }}>
              <input type="password"
                     value={confirmNewPassword}
                     required
                     placeholder="Confirm new password"
                     onChange={e => updateChangePassword({confirmNewPassword: e.target.value})}/>
            </InputValidator>
          </div>
          <div className="small-12 columns">
            <button type="button"
onClick={this.onChangePasswordClick.bind(this)}
                    className="button ba-default-btn">
              Change password
            </button>
          </div>
        </div>
        <ChangeEmail email={profile.email}
                     savedNewEmail={profile.newEmail}
                     isNewEmailConfirmed={profile.isNewEmailConfirmed}
                     errors={errors}
                     onChangeEmail={changeEmail.bind(this)}
                     onResendConfirmationEmail={resendConfirmEmail.bind(this)}
                     onResendVerificationEmail={resendVerifyEmail.bind(this)}
                     onCancelChangeEmail={cancelChangeEmail.bind(this)}/>
      </div>
    );
  }

  onChangePasswordClick() {
    const {currentPassword, newPassword} = this.props.passwordEdit;

    if (this.context.isComponentValid()) {
      this.props.changePassword(currentPassword, newPassword);
    }
  }

  validatePasswords() {
    const {newPassword, confirmNewPassword} = this.props.passwordEdit;
    if (newPassword !== confirmNewPassword) {
      return 'Both passwords must be equal';
    }
  }
}

function mapStateToProps(state) {
  return {...state.profile};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ...ChangeEmailActions,
    ...ProfileActions
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(
  ValidatedComponent(
    ProfileSecurity)
);


// WEBPACK FOOTER //
// ./shared/profile/ProfileSecurity.jsx